var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDaum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_15829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 5.83C13.8556 5.83 16.1656 8.316 16.0556 11.1958C15.9522 13.9348 13.6158 16.17 10.8746 16.17H7.2578C7.0158 16.17 6.8178 15.972 6.8178 15.73V6.27C6.8178 6.028 7.0158 5.83 7.2578 5.83H10.9978M11 0H2.2C1.4718 0 0.880005 0.5918 0.880005 1.32V20.68C0.880005 21.4082 1.4718 22 2.2 22H11C17.0742 22 22 17.0742 22 11C22 4.9258 17.0742 0 11 0Z",
    fill: "#273552"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_15829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaum);
export default __webpack_public_path__ + "static/media/daum.67f40ce8c7446ef6b9a3d35e0ce509aa.svg";
export { ForwardRef as ReactComponent };